import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPrepState100 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 3.03443,
			cy: 8.00037,
			r: 1.93103,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8.00037,
			r: 1.93103,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 12.9655,
			cy: 8.00037,
			rx: 1.93103,
			ry: 1.93103,
			fill: "currentColor"
		})
	]
});
export default SvgPrepState100;
